/* eslint-disable react-hooks/exhaustive-deps */
import React, { useCallback, useEffect, useState, useRef } from 'react';
import { Trans, useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import PlanActions from "../../Redux/transition/plan/plan.reducer";
import SubscriberActions from "../../Redux/transition/subscriber/subscriber.reducer";
import PaymentTrackActions from "../../Redux/transition/payment-track/payment-track.reducer";
import BusinessActions from "../../Redux/actions/business-actions"
import PaySwitchActions from "../../Redux/transition/payswitch/payswitch.reducer";
import DocumentActions from '../../Redux/transition/document-upload/document-upload.reducer';
import Loading from "../../Components/Loading";
import { Dialog } from 'primereact/dialog';
import { Toast } from "primereact/toast";
import { Button } from 'primereact/button';
import InviteSubscriber from "../Subscriptions/Invitation/InviteSubscriber"
import "../../Styles/pages/products.scss"
import "../../Styles/dataTable.scss"
import CustomDataTable from '../../Components/CustomDataTable';
import PlanEdit from './PlanEdit';
import PlanDetailCards from './planDetailCards';
import { Paginator } from 'primereact/paginator';
import MarkAsPaid from '../../Components/MarkAsPaid';
import OnboardingNotification from '../../Components/OnboardingNotification';
import SigningPendingNotice from '../../Components/SigningPendingNotice';
import GoLiveOutstandingDialog from '../../Components/GoLiveOutstandingDialog';
import { hasCurrentProviderCredentials } from '../../utils/pspOnboarding';
import ShareUrl from './ShareUrl';
import PriceChange from './priceChange';
import MoveSubscriber from './MoveSubscribers';
import { useDateFormatter } from "../../Components/FormatDateTime";
import { FormatCurrency, useCurrencyConstants } from '../../Components/CurrencyFormatter';
import RecordPayment from '../Customers/recordPayment';
import CollectPayment from '../Customers/collectPayment';
import { formatBillingPeriodText, removePlusFromNum } from '../../Components/CleanInputs';
import AutoBillingBadge from '../../Components/AutoBillingBadge';

const PlanDetail = () => {

    const { formatDateTime, formatDate } = useDateFormatter();
    const { currencyFormat, currencySymbol } = useCurrencyConstants();

    const { t } = useTranslation("common");
    const { id: planId } = useParams();
    const [displayBasic, setDisplayBasic] = useState(false);
    const navigate = useNavigate();
    const [state, setState] = useState({
        sort: 'id,desc',
        count: null,
        size: 15,
        first: 0,
        collectedSort: "subscriber.lastBilledOn,desc",
        missedSort: "scheduledDate,desc",
        upcomingSort: "scheduledDate,desc",
        externalSort: "externallyReceivedOn,desc",
        subscriptionsSort: "nextBillingDate,desc",
        page: 0,
        plan: {},
        subscribers: [],
        unmounted: false,
        fetching: true,
        planArchiving: false,
        performance: {},
        missed: {},
        pending: [],
        missedCount: 0,
        pendingCount: 0,
        collected: [],
        collectedCount: 0,
        subscriberPlanCount: 0,
        id: null,
        groupExternalPayments: {},
        flex: null,
        tabChange: true,
        sharedPlan: {},
        notOwnerVisible: false,
        priceVisible: false,
        cost: null,
        priceId: null,
        visibleMove: false,
        occurredOn: "receivedAt,desc",
        externalCount: 0,
        showRecordPopup: false,
        showCollectPopup: false,
        goLiveOutstandingVisible: false,
    });
    const [visible, setVisible] = useState(false);
    const [visibleInvite, setVisibleInvite] = useState(false);
    const [nameChangeVisible, setNameChangeVisible] = useState({})
    const [trigger, setTrigger] = useState(false)
    const [activeTab, setActiveTab] = useState(0)
    const [sharePlanDialog, setSharePlanDialog] = useState(false);
    const [openNotification, setOpenNotification] = useState(false);
    const toast = useRef(null);

    const defMembership = useSelector((state) => state.defMembership.defMembership)
    const { plan, archiving, archiveSuccess, errorArchiving, performance, missed,
        fetchingMissed, missedCount, fetchingPaymentMissedCount,
        pending, fetchingPaymentPending, fetchingPending, pendingCount, fetchingPaymentPendingCount, collected, collectedCount, fetchingCollected, fetchingCollectedCount
    } = useSelector((state) => state.plans)
    const { planSubscribers, fetchingPlanSubscribers, fetchingPlan, countSubscribersPlan } = useSelector((state) => state.subscribers)
    const planPayments = useSelector((state) => state.paymentTracks.planPayments);
    const fetchingExternalPayments = useSelector((state) => state.paymentTracks.fetchingPlansExternalPayments)
    const business = useSelector((state) => state.businesses.business);
    const paymentCredentials = useSelector((state) => state.payswitch.credentials);
    const fetchingPaymentCredentials = useSelector((state) => state.payswitch.fetchingCredentials);
    const fetchingVerifStatus = useSelector((state) => state.documents.fetchingVerifStatus);
    const verificationStatus = useSelector((state) => state.documents.verifStatus);
    const signingPending = useSelector((state) => state.documents.signingPending);
    const credentialsSaved = hasCurrentProviderCredentials({
        credentials: paymentCredentials,
        provider: business?.pmtProvider,
    });

    const dispatch = useDispatch();
    const getPlan = useCallback((planId, options) => dispatch(PlanActions.planRequest(planId, options)), [dispatch]);
    const getPlanSubscribers = useCallback((planId, options) => dispatch(SubscriberActions.subscriberPlanRequest(planId, options)), [dispatch])
    const getPlanSubscribersCount = useCallback((planId) => dispatch(SubscriberActions.countingSubscriberPlanRequest(planId)), [dispatch])
    const archivePlan = useCallback((planId, membershipId) => { dispatch(PlanActions.planArchiveRequest(planId, membershipId)) }, [dispatch])
    const planPerformance = useCallback((tierId) => { dispatch(PlanActions.planPerformanceRequest(tierId)) }, [dispatch])
    const getPlanPaymentMissed = useCallback((planId, options) => dispatch(PlanActions.planPaymentMissedRequest(planId, options)), [dispatch])
    const getPlanPaymentMissedCount = useCallback((planId) => dispatch(PlanActions.planPaymentMissedCountRequest(planId)), [dispatch])
    const getPlanPaymentPending = useCallback((planId, options) => dispatch(PlanActions.planPaymentPendingRequest(planId, options)), [dispatch])
    const getPlanPaymentPendingCount = useCallback((planId,) => dispatch(PlanActions.planPaymentPendingCountRequest(planId,)), [dispatch])
    const getPlanPaymentCollected = useCallback((planId, options) => dispatch(PlanActions.planPaymentCollectedRequest(planId, options)), [dispatch])
    const getPlanPaymentCollectedCount = useCallback((planId,) => dispatch(PlanActions.planPaymentCollectedCountRequest(planId,)), [dispatch])
    const getGroupExternalPayments = useCallback((businessId, groupId, options) => { dispatch(PaymentTrackActions.planExternalPaymentsRequest(businessId, groupId, options)) }, [dispatch])
    const getBusiness = useCallback((businessId) => dispatch(BusinessActions.businessRequest(businessId)), [dispatch]);
    const getCredentials = useCallback((businessId, provider) => { dispatch(PaySwitchActions.paySwitchCredentialRequest(businessId, provider)) }, [dispatch]);
    const getBusinessVerificationStatus = useCallback((businessId) => dispatch(DocumentActions.businessVerificationStatusRequest(businessId)), [dispatch]);

    useEffect(() => {
        getBusiness(defMembership.business.id)
        getCredentials(defMembership.business.id, defMembership.business.pmtProvider)
        getPlan(planId);
        getPlanSubscribers(planId, { sort: state.subscriptionsSort, size: state.size });
        getPlanSubscribersCount(planId);
        planPerformance(planId);
        getPlanPaymentMissed(planId, { sort: state.missedSort, size: state.size });
        getPlanPaymentMissedCount(planId)
        getPlanPaymentPending(planId, { sort: state.upcomingSort, size: state.size });
        getPlanPaymentPendingCount(planId)
        getPlanPaymentCollected(planId, { sort: state.occurredOn, size: state.size });
        getPlanPaymentCollectedCount(planId)
        getGroupExternalPayments(defMembership.business.id, planId, { size: state.size })
    }, [trigger]);

    const membershipId = defMembership.id;
    const calenderDateFormat = defMembership?.business?.country?.jsShortDateFormat;
    const countryCurrency = defMembership?.business?.country?.currency;

    useEffect(() => {
        if (plan) {
            setState(state => {
                return {
                    ...state, plan: plan, flex: plan.flex, priceId: plan.id
                }
            });
        }
        if (planSubscribers) {
            setState(state => { return { ...state, subscribers: planSubscribers } });
        }
        if (performance) {
            setState(state => { return { ...state, performance } });
        }
        if (missed) {
            setState((state) => { return { ...state, missed: missed?.content } })
        }
        if (countSubscribersPlan) {
            setState((state) => ({ ...state, subscriberPlanCount: countSubscribersPlan }))
        }
        if (pending) {
            setState((state) => ({ ...state, pending: pending?.content }))
        }
        if (missedCount) {
            setState((state) => ({ ...state, missedCount: missedCount }))
        }
        if (pendingCount) {
            setState((state) => ({ ...state, pendingCount: pendingCount }))
        }
        if (collected) {
            setState((state) => ({ ...state, collected: collected }))
        }
        if (collectedCount) {
            setState((state) => ({ ...state, collectedCount: collectedCount }))
        }
        if (planPayments) {
            setState((state) => ({ ...state, groupExternalPayments: planPayments?.content, externalCount: planPayments?.totalElements }))
        }
        if (!verificationStatus) {
            getBusinessVerificationStatus(defMembership.business.id)
        }
    }, [plan, planSubscribers, performance, collected, collectedCount, countSubscribersPlan,
        planPayments, state.groupExternalPayments, missed, verificationStatus])

    useEffect(() => {
        if (!archiving && state.planArchiving && archiveSuccess) {
            showSuccess({ message: t("product.planArchive_successful"), severity: "success", })
            setState((state) => ({ ...state, planArchiving: false }))
            getPlan(planId);
            getPlanSubscribers(planId, { sort: state.subscriptionsSort, size: state.size });
        }
        if (!archiving && state.planArchiving && errorArchiving) {
            showError()
            setState((state) => ({ ...state, planArchiving: false }))
        }
    }, [state.planArchiving, archiving, errorArchiving, archiveSuccess])

    useEffect(() => {
        switch (activeTab) {
            case 1:
                getPlanPaymentCollected(planId, { page: state.page, sort: state.occurredOn, size: state.size });
                break;
            case 2:
                getPlanPaymentMissed(planId, { page: state.page, sort: state.missedSort, size: state.size });
                break;
            case 3:
                getGroupExternalPayments(defMembership.business.id, planId, { page: state.page, sort: state.externalSort, size: state.size })
                break;
            case 4:
                getPlanPaymentPending(planId, { page: state.page, sort: state.upcomingSort, size: state.size });
                break;
            default:
                getPlanSubscribers(planId, { sort: state.subscriptionsSort, page: state.page, size: state.size });
                break;
        }
    }, [activeTab])

    //Toggle not Owner dialogue visibility
    const toggleGoLiveOutstandingDialogue = () => { setState((state) => { return { ...state, goLiveOutstandingVisible: !state.goLiveOutstandingVisible }; }); };
    const openGoLiveOutstandingDialog = () => {
        toggleGoLiveOutstandingDialogue();
    };
    //Toggle not Owner dialogue visibility
    const toggleNotOwnerDialogue = () => { setState((state) => { return { ...state, notOwnerVisible: !state.notOwnerVisible }; }); };

    const showSuccess = (data) => { toast.current.show({ severity: 'success', summary: t("success"), detail: data.message, life: 3000 }); }
    const showError = () => { toast.current.show({ severity: 'error', summary: t("failed"), detail: t("product.archive_error"), life: 3000 }); }

    if (fetchingPlanSubscribers || fetchingPaymentMissedCount ||
        fetchingPaymentPendingCount ||
        fetchingPaymentPending || fetchingCollectedCount) {
        return <Loading />;
    }
    const accept = () => {
        setState((state) => ({ ...state, planArchiving: true }))
        archivePlan(state.plan.id, defMembership.id)
        toast.current.show({ severity: 'info', summary: t("product.archive"), detail: t("products.archive_plan_info"), life: 3000 });
    }

    const reject = () => { setVisible(false) }

    const toggleShareProduct = () => {
        if (fetchingVerifStatus || fetchingPaymentCredentials) {
            return <Loading />;
        } else {
            if (signingPending && business.verified && credentialsSaved) {
                return openGoLiveOutstandingDialog();
            }
            if (!business.verified) {
                if (state.verifStatus && !state.fetchingVerifRecord) { return openGoLiveOutstandingDialog(); }
                if (!state.verifStatus && !state.fetchingVerifRecord) {
                    switch (defMembership.role) {
                        case "OWNER":
                            setOpenNotification(true);
                            break;
                        default:
                            toggleNotOwnerDialogue();
                    }
                }
            }
            if (state.verifStatus && !paymentCredentials) {
                switch (defMembership.role) {
                    case "OWNER":
                        setOpenNotification(true)
                        break;
                    default:
                        toggleNotOwnerDialogue();
                }
            }
        }
    };

    const togglePriceChange = (data) => {
        setState({ ...state, priceVisible: true, cost: data.cost, priceId: data.id });
    };

    const priceOnHide = () => {
        setState({ ...state, priceVisible: false });
    };

    const closeMoveSubscriber = () => { setState((state) => ({ ...state, visibleMove: false })); };

    const toggleMoveSubscriber = () => { setState((state) => ({ ...state, visibleMove: !state.visibleMove })); };

    const planShare = () => {
        if (plan.policy === "TARGET") return;
        if (!business.verified || !paymentCredentials || signingPending) {
            toggleShareProduct()
        }
        else {
            setSharePlanDialog(true);
            setState((state) => ({
                ...state,
                sharedPlan: {
                    shortUrl: plan.shortUrl,
                    plan: plan.name,
                    planDescription: plan.description,
                    planId: plan.id,
                    planGroupId: plan.group?.id,
                    reportable: plan.group.reportable,
                    reportCode: plan.group.reportCode,
                },
            }));
        }
    }

    const dateFormatterBody = (rowData, e) =>
        <div className="dateFormatterBody-div">
            <p className='nextBillingDate-p'>{rowData?.nextBillingDate ? formatDateTime(rowData?.nextBillingDate) : "--"}</p>
        </div>

    const dateFormatter = (rowData, e) => {
        return (<div className="joinedOn-div">
            <p className="joinedOn-p">{rowData?.joinedOn ? formatDate(rowData?.joinedOn) : "--"}</p>
        </div>)
    }

    const statusTemplate = (rowData, e) => {
        return rowData[e.field] && <div className='stat-column'>
            <span className={`stat-column-span product-badge status-${(rowData[e.field] ? rowData[e.field].toLowerCase() : '')}`}>{rowData[e.field]}</span>
            {rowData.status === "CANCELLED" && <div className="status-bottom-text" >
                <div className="space align"> <span className="labelOn">{t("subscriber.occurred_on")}</span></div>
                <div><p className="labelOnDate align">{formatDate(rowData.cancelledOn)}</p></div>
            </div>}
            {rowData.status === "COMPLETE" && <div className="status-bottom-text" >
                <div className="space align"> <span className="labelOn">{t("subscriber.occurred_on")}</span></div>
                <div><p className="labelOnDate align">{formatDate(rowData.completedOn)}</p></div>
            </div>}
            {rowData.status === "PAUSED" && <div className="status-bottom-text">
                <div className="space align"> <span className="labelOn">{t("subscriber.occurred_on")}</span></div>
                <div><p className="labelOnDate align">{formatDate(rowData.pausedOn)}</p></div>
            </div>}
        </div>
    }

    const referenceTemplate = (rowData) =>
        <div className="referenceTemplate-div" >
            <span className='link referenceTemplate-span'
                onClick={() =>
                    navigate(`/crm/customers/customer/subscription/${rowData.id}`)}
            >{rowData.subscriberReference}</span>
        </div>

    const markActionTemplate = (rowData) => {
        if (rowData) {
            return (rowData.subscriptionStatus === "ACTIVE" ? <span
                id='plan-detail-mark-action'
                className="p-button-warning p-button-rounded p-button-text mr-2 customerAction"
                onClick={() => {
                    setDisplayBasic(true)
                    setState((state) => ({
                        ...state,
                        id: rowData.id,
                        scheduledDate: rowData.scheduledDate
                    }));
                }}>{t("subscriber.paid")}</span>
                : "")
        }
    }

    const paymentIdTemplate = (rowData) => {
        if (rowData) {
            return <div id="paymentIdTemplatePlan">
                <p>{rowData.latestDlr.id}</p>
            </div>
        }
    }

    const occurredOnTemplate = (rowData) => {
        const externallyReceivedData = rowData.externallyReceivedBy;
        if (rowData) {
            return <div className='flex flex-column occurredOn-div'>
                <span className='tier-date'>
                    {formatDate(rowData.externallyReceivedOn)}
                </span>
                <p className='m-0'>
                    <Trans i18nKey="pay_mode" values={{ mode: formatBillingPeriodText(rowData.externalMode) }}
                        components={{ 1: <span className='text-sm' />, 2: <span className='mode-title text-sm ml-0' /> }} />
                </p>
                <p className='m-0'>
                    <Trans i18nKey="marked_by" values={{ markedBy: externallyReceivedData.user.name }}
                        components={{ 1: <span className='text-sm' />, 2: <span className='mode-title text-sm ml-0' /> }} />
                </p>
            </div>
        }
    }

    const costTemplate = (rowData) => {
        if (rowData) {
            return <div className='cost-template-occurredOn'>
                {
                    rowData.subscription.plan?.flex === true ?
                        <div>
                            {rowData.extReceivedAmount &&
                                <FormatCurrency
                                    amount={rowData.extReceivedAmount}
                                    currencySymbol={currencySymbol}
                                    currencyFormat={currencyFormat}
                                    className="transactions_data"
                                />
                            }
                        </div>
                        :
                        <FormatCurrency
                            amount={rowData.cost}
                            currencySymbol={currencySymbol}
                            currencyFormat={currencyFormat}
                            className="transactions_data"
                        />
                }
            </div>
        }
    }

    const notesTemplate = (rowData) => {
        if (rowData) {
            return <div className='notesTemplate-div'>
                {rowData.extReceivedNotes ?
                    <p> {rowData.extReceivedNotes}</p> : null
                }
            </div>
        }
    }

    const paymentSubscriptionBodyTemplate = (rowData) => {
        const rowPlan = rowData.subscription.plan;
        console.log(rowData);

        if (rowData) {
            return <div className="subscriptionBodyTemplatePlan">
                {rowPlan?.policy ? <span className="policy"> {rowPlan?.policy === "FIXED" ? t("products.fixed_billing").toUpperCase() : rowPlan?.policy === "CUSTOM" ? t("products.custom_billing").toUpperCase() : t('billing', { val: rowPlan?.policy })} </span> : null}
                {
                    rowPlan?.groupName &&
                    <p className="mb-0 plan-text detail-navigation hover-click"
                        onClick={() => {
                            navigate(`/products/detail/${rowPlan.groupId}`)
                        }}>
                        {rowPlan.groupName}
                    </p>
                }
                {
                    rowPlan?.name ?
                        <div className="flex align-items-center gap-2">
                            <span className="mb-2 tier-name-content">
                                {rowPlan.name !== null ? rowPlan.name : ""}
                            </span>
                            <AutoBillingBadge collectionMode={rowPlan.collectionMode} />
                        </div> : null
                }
                {
                    rowData.subscription.subscriberReference !== null ?
                        <p className="mb-0 cus-text cursor-pointer hover-click"
                            onClick={() => {
                                if (rowData.subscription.id)
                                    navigate({ pathname: `/crm/customers/customer/subscription/${rowData.subscription.id}`, rowData });
                            }}
                        >
                            {rowData.subscription.subscriberReference}
                        </p>
                        : ""
                }
                {rowData.subscription.businessCustomer ? <span id="tierSub" > {rowData.subscription.businessCustomer.name} </span> : null}
                {rowData.subscription.businessCustomer ? <span id="tierSub"> {removePlusFromNum(rowData.subscription.businessCustomer.phoneNo)} </span> : null}

            </div >
        }
    }

    const planCustomerTemplate = (tier) => {
        if (tier) {
            return <div>
                {tier.subscriber.businessCustomer?.customerNum === null ? <div className="planCustomerTemplate">
                    <span className="link plan-name-link_bold"
                        onClick={() =>
                            navigate("/crm/customers/customer/subscription/" + tier.subscriber.id)
                        }>{tier.subscriber.businessCustomer?.name}
                    </span>
                    <span className="plan-phone">{removePlusFromNum(tier.subscriber.businessCustomer?.phoneNo)}</span>
                    <span className="plan-email">{tier.subscriber.businessCustomer?.email}</span>
                </div> :
                    <div className="planCustomerTemplate">
                        <span className="plan_customerNum">{tier.subscriber.businessCustomer?.customerNum}</span>
                        {tier.subscriber.businessCustomer?.customerNum === null ? <span className="link plan-name-link_bold"
                            onClick={() =>
                                navigate("/crm/customers/customer/subscription/" + tier.subscriber.id)}
                        >{tier.subscriber.businessCustomer?.name}
                        </span> : <span className="link plan-name-link"
                            onClick={() =>
                                navigate("/crm/customers/customer/subscription/" + tier.subscriber.id)}
                        >{tier.subscriber.businessCustomer?.name}
                        </span>}
                        <span className="plan-phone">{removePlusFromNum(tier.subscriber.businessCustomer?.phoneNo)}</span>
                        <span className="plan-email">{tier.subscriber.businessCustomer?.email}</span>
                    </div>}
            </div>
        }
    }

    const subsTemplate = (rowData) => {
        if (rowData) {
            return <>
                {rowData.businessCustomer?.customerNum === null ? <div className="subsClassTemplate">
                    <span className="link plan-name-link_bold"
                        onClick={() =>
                            navigate("/crm/customers/customer/subscription/" + rowData.id)}
                    >{rowData.businessCustomer?.name}
                    </span>
                    <span className="plan-phone">{removePlusFromNum(rowData.businessCustomer?.phoneNo)}</span>
                    <span className="plan-email">{rowData.businessCustomer?.email}</span>
                </div> :
                    <div className="subsTemplate-div">
                        <span className="plan_customerNum">{rowData.businessCustomer?.customerNum}</span>
                        {rowData.businessCustomer?.customerNum === null ? <span className="link plan-name-link_bold"
                            onClick={() =>
                                navigate("/crm/customers/customer/subscription/" + rowData.id)}
                        >{rowData.businessCustomer?.name}
                        </span> : <span className="link plan-name-link"
                            onClick={() =>
                                navigate("/crm/customers/customer/subscription/" + rowData.id)}
                        >{rowData.businessCustomer?.name}
                        </span>}
                        <span className="plan-phone">{removePlusFromNum(rowData.businessCustomer?.phoneNo)}</span>
                        <span className="plan-email">{rowData.businessCustomer?.email}</span>
                    </div>}
            </>
        }
    }
    const upcomingSubsTemplate = (rowData) => {
        if (rowData) {
            return <>
                {rowData.businessCustomer?.customerNum === null ? <div className="upcoming-subs-template">
                    <p className="link upcoming-name-link-bold"
                        onClick={() =>
                            navigate("/crm/customers/customer/subscription/" + rowData.id)}
                    >{rowData.businessCustomer?.name}
                    </p>
                    <p className="upcoming-phone">{removePlusFromNum(rowData.businessCustomer?.phoneNo)}</p>
                    <p className="upcoming-email">{rowData.businessCustomer?.email}</p>
                </div> :
                    <div className="upcoming-subs-template-div">
                        <p className="upcoming-customerNum">{rowData.businessCustomer?.customerNum}</p>
                        {rowData.businessCustomer?.customerNum === null ?
                            <p className="link upcoming-name-link-bold"
                                onClick={() => navigate("/crm/customers/customer/subscription/" + rowData.id)} >{rowData.businessCustomer?.name} </p>
                            : <p className="link plan-name-link"
                                onClick={() =>
                                    navigate("/crm/customers/customer/subscription/" + rowData.id)}>{rowData.businessCustomer?.name}
                            </p>}
                        <p className="upcoming-phone">{removePlusFromNum(rowData.businessCustomer?.phoneNo)}</p>
                        <p className="upcoming-email">{rowData.businessCustomer?.email}</p>
                    </div>}
            </>
        }
    }

    const collectedAmountTemplate = (tier) => {
        if (tier) {
            return <div className="collectedAmountTemplate-div">
                <FormatCurrency
                    amount={tier?.amount}
                    currencySymbol={currencySymbol}
                    currencyFormat={currencyFormat}
                    className="collected_amount mb-1"
                />
                {
                    tier.setupAmount !== null ? <div>
                        <div className="mb-1" style={{ display: "flex" }}>
                            <span style={{ color: "#000", fontWeight: "bold", fontSize: "12px" }}>{t("subscriber.amount")}{":"}</span>
                            {" "}<FormatCurrency
                                amount={tier.plan.cost ? tier.plan.cost : tier.originalAmount}
                                currencySymbol={currencySymbol}
                                currencyFormat={currencyFormat}
                                className="tier-cost"
                            />
                        </div>
                        <p className="setup_fee_div" id="setup-m-b">
                            <span className="setup_fee_tag">{t("common.setup_fee_label")}</span>
                            <FormatCurrency
                                amount={tier.setupAmount}
                                currencySymbol={currencySymbol}
                                currencyFormat={currencyFormat}
                                className="setup_fee_value"
                            />
                        </p>
                    </div> : ""
                }
            </div>
        }
    }

    const serviceFeeTemplate = (tier) => {
        if (tier) {
            return <div className="serviceFeeTemplate-div">
                <FormatCurrency
                    amount={tier?.fees}
                    currencySymbol={currencySymbol}
                    currencyFormat={currencyFormat}
                    className="plan_revenue"
                />
            </div>
        }
    }
    const revenueTemplate = (tier) => {
        if (tier) {
            return <div className="revenueTemplate-div">
                <FormatCurrency
                    amount={tier?.redeemable}
                    currencySymbol={currencySymbol}
                    currencyFormat={currencyFormat}
                    className="plan_redeemable"
                />
            </div>
        }
    }

    const receivedAtBodyTemplate = (tier) => {
        if (tier) {
            return <div className='receivedAt-main-div'>
                <span className="receivedAt-spans">{formatDateTime(tier?.receivedAt)}</span>
            </div>
        }
    }

    const planScheduledDate = (tier) => {
        if (tier) {
            return <div className="planScheduledDate_div">
                <p className={`failed_scheduleStatus subscription-status status-${tier.scheduleStatus}`}>
                    {tier.scheduleStatus?.toUpperCase()}</p>
                <p className="cust-scheduledFor">{t("subscriber.scheduled_for")}</p>
                <p className="scheduledFor">{formatDateTime(tier?.scheduledFor)}</p>
            </div>
        }
    }

    const failedAmountTemplate = (rowData, e) => {
        if (rowData) {
            return <div className="col_amounts_flex">
                {rowData?.amountDue ?
                    <FormatCurrency
                        amount={rowData?.amountDue}
                        currencySymbol={currencySymbol}
                        currencyFormat={currencyFormat}
                        className=""
                    /> : t("subscriber.flex_true")}
            </div>;
        }
    }

    const upcomingPaymentsSchedule = (tier) => {
        if (tier) {
            return <div className='upcoming-payment-date-div'>
                <p
                    className={`upcoming-payment-date-p subscription-status status-${tier.scheduleStatus}`}>
                    {tier.scheduleStatus.toUpperCase()}</p>
                <p className="cust-scheduledFor">{t("subscriber.scheduled_for")}</p>
                <p className="scheduledFor scheduledFor_pb">{formatDateTime(tier.scheduledFor)}</p>
            </div>
        }
    }

    const upcomingAmountTemplate = (rowData, e) => {
        if (rowData) {
            return <div id="updcoming_col_amounts">
                <FormatCurrency
                    amount={rowData?.amountDue}
                    currencySymbol={currencySymbol}
                    currencyFormat={currencyFormat}
                    className="upcoming-amount"
                />
            </div>
        }
    }

    const failedTransactionColumns = [
        { field: "scheduledDate", body: planScheduledDate, header: t("products.payment_schedule"), headerClassName: "failed-transaction-column failed_transaction_status" },
        {
            field: "customer.name", header: t("plan.subscriber"), headerClassName: "failed-transaction-column class1", body: subsTemplate
        },
        { field: "amountDue", header: t("amount"), body: failedAmountTemplate, headerClassName: "failed-transaction-column" },
        { body: markActionTemplate }
    ]

    const upcomingPaymentColumn = [
        {
            field: "scheduledDate", body: upcomingPaymentsSchedule, header: t("products.payment_schedule"),
            headerClassName: "upcoming-payments-column upcoming-schedule-payments"
        },
        {
            field: "customer.name", header: t("products.customer_info"), body: upcomingSubsTemplate,
            headerClassName: "upcoming-payments-column"
        },
        {
            field: "amountDue", header: t("amount"), body: upcomingAmountTemplate,
            headerClassName: "upcoming-payments-column"
        }
    ]

    const externalPayments = [
        { field: 'id', body: paymentIdTemplate, header: t("products.ref"), headerClassName: "amount-header" },
        { field: 'subscriber', body: paymentSubscriptionBodyTemplate, header: t("subscriber.info"), headerClassName: "subsTemplate-header" },
        { field: 'externallyReceivedOn', body: occurredOnTemplate, header: t("subscriber.occurred_on"), headerClassName: "amount-header" },
        { field: 'extReceivedAmount', body: costTemplate, header: t("dashboard.amount"), headerClassName: "amount-header" },
        { body: notesTemplate, header: t("subscriber.notes"), headerClassName: "amount-header" },
    ]

    const tabs = [{
        label: "subscriber.title", columns: [
            { field: "status", body: statusTemplate, header: t("products.status"), bodyClassName: "status-spacing-content" },
            { field: "subscriberReference", header: t("subscriber.subs_id"), body: referenceTemplate, alignHeader: "left", bodyClassName: "ref-spacing" },
            { header: t("subscriber.info"), body: subsTemplate, alignHeader: "left", bodyClassName: "" },
            { field: "joinedOn", body: dateFormatter, header: t("products.joined_on"), alignHeader: "left", bodyClassName: "date-spacing" },
            { field: "nextBillingDate", body: dateFormatterBody, header: t("products.next_billing_date"), alignHeader: "left" },
        ],
        value: state.subscribers, count: state.subscribers.length, index: 0
    }, {
        label: "dashboard.collected", columns: [
            {
                field: "customer.reference", header: t("products.payment_id"), headerClassName: "plan_payment_id",
                body: (tier) => <p className="payment-ref"
                    onClick={() =>
                        navigate("/payments/detail/" + tier.id)}
                >{tier.reference}</p>
            },
            {
                field: "customer.name", header: t("products.customer_info"), body: planCustomerTemplate, headerClassName: "plan_subscriber_info"
            },
            { field: "receivedAt", body: receivedAtBodyTemplate, header: t("products.paid_on"), headerClassName: "plan_paid_on" },
            {
                field: "paymentMode", header: t("recipient.payment_channel_1"), headerClassName: "plan_paymentMode",
                body: (tier) => <div className='plan_paymentMode_div'><p className="plan_paymentMode">{tier.paymentMode}</p></div>
            },
            { field: "amount", header: t("product.collected"), body: collectedAmountTemplate, headerClassName: "plan_collected" },
            { field: "fees", header: t("subscriber.service_fee"), body: serviceFeeTemplate, headerClassName: "plan_fees" },
            { field: "redeemable", header: t("common.revenue"), body: revenueTemplate, headerClassName: "plan_redeemable" },
        ],
        value: state.collected, count: state.collectedCount, paginator: true, index: 1

    },
    {
        label: t('subscriber.failed_transaction'), value: state.missed,
        columns: failedTransactionColumns, count: state.missedCount, index: 2
    },
    {
        label: t('transaction.external_payment'), value: state.groupExternalPayments, columns: externalPayments, count: state.externalCount, paginator: true, index: 4
    },
    {
        label: t('subscriber.upcoming'), value: state.pending,
        columns: upcomingPaymentColumn, count: state.pendingCount, index: 3
    },
    ]

    const archiveFooter = () => {
        return (
            <div>
                <Button
                    id="footer-btn-cancel"
                    label={t("cancel")}
                    icon="pi pi-times"
                    onClick={reject}
                />
                <Button
                    id="archive-btn"
                    loading={archiving}
                    label={t("share.archive")}
                    icon="pi pi-check"
                    onClick={() => { accept(); }}
                />
            </div>
        );
    };

    const toggleInvite = () => {
        setVisibleInvite(false)
    }

    const totalNumber = tabs[activeTab].index === 0
        ? state.subscriberPlanCount
        : tabs[activeTab].index === 1
            ? state.collectedCount
            : tabs[activeTab].index === 2
                ? state.missedCount
                : tabs[activeTab].index === 3
                    ? state.pendingCount
                    : tabs[activeTab].index === 4
                        ? state.externalCount
                        : null

    const onPageChange = (e) => {
        if (e.pageCount <= 1) {
            return;
        }
        else if (tabs[activeTab].index === 0) {
            getPlanSubscribers(planId, { page: e.page, sort: state.subscriptionsSort, size: state.size });
            setState((state) => { return { ...state, page: e.page, first: e.first } })
        }
        else if (tabs[activeTab].index === 1) {
            getPlanPaymentCollected(planId, { page: e.page, sort: state.occurredOn, size: state.size });
            setState((state) => { return { ...state, page: e.page, first: e.first } })
        }
        else if (tabs[activeTab].index === 2) {
            getPlanPaymentMissed(planId, { page: e.page, sort: state.missedSort, size: state.size });
            setState((state) => { return { ...state, page: e.page, first: e.first } })
        }
        else if (tabs[activeTab].index === 3) {
            getPlanPaymentPending(planId, { page: e.page, sort: state.upcomingSort, size: state.size });
            setState((state) => { return { ...state, page: e.page, first: e.first } })
        }
        else if (tabs[activeTab].index === 4) {
            getGroupExternalPayments(defMembership?.business.id, planId, { page: e.page, sort: state.externalSort, size: state.size })
            setState((state) => { return { ...state, page: e.page, first: e.first } })
        }
        else {
            return;
        }
    }

    const loading = fetchingCollected || fetchingPlanSubscribers || fetchingMissed || fetchingPending || fetchingExternalPayments || fetchingPlan;

    const renderVerifFooter = (component) => {
        return (
            <div>
                <Button
                    label={t("common.ok")}
                    icon="pi pi-check"
                    style={{ backgroundColor: "#d0021b" }}
                    autoFocus
                    onClick={toggleNotOwnerDialogue}
                />
            </div>
        );
    };
    const toggleSetOpenDialog = () => { setOpenNotification(!openNotification); };

    const tableClassNameFunc = () => {
        if (tabs[activeTab].index === 1) {
            return 'collectPaymentsTab';
        } else if (tabs[activeTab].index === 2) {
            return 'failedTransactionColumn';
        } else if (tabs[activeTab].index === 3) {
            return 'upcomingPaymentsColumn';
        }
        return 'tier_detail_data_table';
    }

    return (
        <div className='planDetailScreen plan-detail-screen'>
            <Toast
                onRemove={(message) => {
                    if (message.severity === "success") {
                        setVisible(false);
                    }
                }} ref={toast} />
            <PriceChange
                toggle={togglePriceChange}
                toggleState={state.priceVisible}
                oldPrice={state.cost?.toFixed(2)}
                id={state.priceId}
                onHide={priceOnHide}
                defMembership={defMembership}
                callbackFunctions={() => {
                    getBusiness(defMembership?.business.id)
                    getCredentials(defMembership?.business.id, defMembership.business.pmtProvider)
                    getPlan(planId);
                    getPlanSubscribers(planId, { sort: state.subscriptionsSort, size: state.size });
                    planPerformance(planId);
                    getPlanPaymentMissed(planId, { size: state.size });
                    getPlanPaymentMissedCount(planId)
                    getPlanPaymentPending(planId, { sort: state.upcomingSort, size: state.size });
                    getPlanPaymentPendingCount(planId)
                    getPlanPaymentCollected(planId, { sort: state.occurredOn, size: state.size });
                    getPlanPaymentCollectedCount(planId)
                    getGroupExternalPayments(defMembership?.business.id, planId, { size: state.size })
                }}
            />
            <ShareUrl
                visible={sharePlanDialog}
                setShareDialog={setSharePlanDialog}
                sharedTier={state.sharedPlan}
                copying={state.copying}
            />
            <MoveSubscriber
                visible={state.visibleMove}
                onHide={closeMoveSubscriber}
                sourceTier={state.sourceTier}
            />
            <MarkAsPaid displayDialog={displayBasic} onHide={() => { setDisplayBasic(false) }}
                scheduleId={state.id}
                isFlexTrue={state.flex}
                scheduledDate={state.scheduledDate}
                callbackFunctions={() => {
                    getPlan(planId);
                    getPlanSubscribers(planId, { sort: state.subscriptionsSort, size: state.size });
                    planPerformance(planId);
                    getPlanPaymentMissed(planId);
                    getPlanPaymentMissedCount(planId)
                    getPlanPaymentPending(planId, { sort: state.upcomingSort, size: state.size });
                    getPlanPaymentPendingCount(planId)
                    getPlanPaymentCollected(planId, { sort: state.occurredOn, size: state.size });
                    getPlanPaymentCollectedCount(planId)
                    getGroupExternalPayments(defMembership?.business.id, planId)
                }}
            />
            <InviteSubscriber visible={visibleInvite} toggleVisible={visibleInvite}
                onHide={toggleInvite} initialTier={{ data: state.plan }}
                setVisibleInvite={toggleSetOpenDialog}
                callbackFunctions={() => {
                    getBusiness(defMembership?.business.id)
                    getCredentials(defMembership?.business.id, defMembership.business.pmtProvider)
                    getPlan(planId);
                    getPlanSubscribers(planId, { sort: state.subscriptionsSort, size: state.size });
                    planPerformance(planId);
                    getPlanPaymentMissed(planId, { size: state.size });
                    getPlanPaymentMissedCount(planId)
                    getPlanPaymentPending(planId, { sort: state.upcomingSort, size: state.size });
                    getPlanPaymentPendingCount(planId)
                    getPlanPaymentCollected(planId, { sort: state.occurredOn, size: state.size });
                    getPlanPaymentCollectedCount(planId)
                    getGroupExternalPayments(defMembership?.business.id, planId, { size: state.size })
                }} />
            <PlanEdit tier={nameChangeVisible} onHide={() => setNameChangeVisible({})} setTrigger={setTrigger} trigger={trigger} />
            <PriceChange
                toggle={togglePriceChange}
                toggleState={state.priceVisible}
                oldPrice={state.cost?.toFixed(2)}
                id={state.priceId}
                onHide={priceOnHide}
                defMembership={defMembership}
            />
            <MoveSubscriber
                visible={state.visibleMove}
                onHide={closeMoveSubscriber}
                sourceTier={state.sourceTier}
            />
            <CollectPayment
                {...{ state, setState, countryCurrency, membershipId, defMembership }}
                callBack={() => getPlanSubscribers(planId, { sort: state.subscriptionsSort, size: state.size })}
            />
            <RecordPayment
                {...{ state, setState, calenderDateFormat, countryCurrency, membershipId, defMembership }}
                callBack={() => getPlanSubscribers(planId, { sort: state.subscriptionsSort, size: state.size })}
            />
            <Dialog
                header={t("products.archive_header_plan")}
                visible={visible}
                onHide={() => setVisible(false)}
                footer={archiveFooter()}
                className="tier_dialog"
                id="tier_dialog"
                style={{ width: "300px" }}
            >
                <div className="archive-dialog-content">
                    <p style={{ display: "flex", justifyContent: "center" }}>
                        <i className="pi pi-exclamation-circle archive-dialog-icon" />
                    </p>
                    <div style={{ padding: "10px" }}>
                        <div style={{ marginBottom: "0.5rem" }}>
                            <span>
                                {t("products.archive_question_plan", { name: state.plan.name })}{" "}
                                <span style={{ fontWeight: "bold", color: "#000" }}>
                                    {state.rowData?.name}
                                </span>{"?"}{" "}
                            </span>
                        </div>
                        <p className="archive-notice">
                            {t("product.archive_notice")}
                        </p>
                    </div>
                    <hr style={{ border: "1px solid #F2F2F2" }} />
                </div></Dialog>

            <PlanDetailCards  {...{
                state, setState, t, defMembership, setVisible, setVisibleInvite,
                setNameChangeVisible, toggleMoveSubscriber, togglePriceChange, planShare,
            }} />
            <GoLiveOutstandingDialog
                visible={state.goLiveOutstandingVisible}
                onHide={toggleGoLiveOutstandingDialogue}
            />
            <Dialog
                header={t("idoc.not_owner_header")}
                visible={state.notOwnerVisible}
                style={{ width: "360px" }}
                onHide={toggleNotOwnerDialogue}
                footer={renderVerifFooter("not_owner")}
            >
                <p>{t("idoc.not_owner_text")}</p>
                <SigningPendingNotice business={business} />
            </Dialog>
            <OnboardingNotification
                visible={openNotification}
                onHide={toggleSetOpenDialog} />
            <CustomDataTable
                value={tabs[activeTab].value}
                columns={tabs[activeTab].columns}
                tabs={tabs.map(({ label, i }) => ({ label, i }))}
                setActiveTab={setActiveTab}
                activeTab={activeTab}
                setState={setState}
                tableClassName={tableClassNameFunc()}
                title="products.plan_activity"
                children={null}
                rows={state.size}
                loading={loading}
                tab={state.tabChange}
            />
            <Paginator
                rows={state.size}
                first={state.first}
                totalRecords={totalNumber}
                onPageChange={onPageChange}
            />
        </div >
    )
}
export default PlanDetail;